//seeds.ts

import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";
import { Seed, SeedUseRecord, SeedStockHistoryRecord } from "../../models/seed";
import { RunSeedAuditRequest } from "../../models/seed";

export const seedsApi = {
  add: (seed: Seed): Promise<Seed> =>
    apiProvider
      .post("seeds", {
        data: seed,
      })
      .then((d: JsonDocument<Seed>) => d.data),

  update: (seed: Seed): Promise<Seed> =>
    apiProvider.put("seeds", seed.id, {
      data: seed,
    }),

  getSingle: (id: number): Promise<Seed> =>
    apiProvider.getSingle("seeds", id).then((d: JsonDocument<Seed>) => d.data),

  getAll: (): Promise<Seed[]> =>
    apiProvider.getAll("seeds").then((d: JsonDocument<Seed[]>) => d.data),

  getUseRecords: (): Promise<SeedUseRecord[]> =>
    apiProvider
      .getAll("seeds/use-records")
      .then((d: JsonDocument<any[]>) => d.data),

  getStockHistory: (): Promise<SeedStockHistoryRecord[]> =>
    apiProvider
      .getAll("seeds/stock-history")
      .then((d: JsonDocument<SeedStockHistoryRecord[]>) => d.data),

  runAudit: (data: RunSeedAuditRequest): Promise<void> =>
    apiProvider.post("seeds/audit", {
      data,
    }),

  updateAudit: (
    transactionId: number,
    data: {
      countedStockKg: number;
      notes: string;
    },
  ): Promise<void> =>
    apiProvider.put("seeds/audit", transactionId, {
      data,
    }),

  trash: (id: number): Promise<any> => apiProvider.remove("seeds", id),
};
